import React from "react";
import Attachment from "./attachment";
import ProgressBar from "./progress_bar";

export default class AttachmentList extends React.Component {
    state = {
        loading: true,
        error: false,
        attachments: [],
        placing_file: false
    };

    constructor(props) {
        super(props);
        this.fetching = false;
        this.current_page = 1;
        this.total_attachment_count = 0;
    }

    componentDidMount() {
        window.addEventListener("resize", this.fetchMoreAttachments, false);
        window.addEventListener(
            "com.brandfolder.attachment_browser.close_progress_bar",
            this.hideProgressBar,
            false
        );
        this.getAttachments();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.fetchMoreAttachments);
        window.removeEventListener(
            "com.brandfolder.attachment_browser.close_progress_bar",
            this.hideProgressBar
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.search_query != prevProps.search_query) {
            this.current_page = 1;
            this.total_attachment_count = 0;
            this.setState(
                { loading: true, error: false, attachments: [] },
                () => {
                    this.getAttachments();
                }
            );
        }
    }

    showProgressBar = () => {
        this.setState({ placing_file: true });
    };

    hideProgressBar = () => {
        this.setState({ placing_file: false });
    };

    getAttachments() {
        this.fetching = true;
        let url = `/api/v4/brandfolders/${
            this.props.selected_brandfolder.id
        }/attachments?fields=thumbnail_url,download_url,image_type,updated_at&page=${
            this.current_page
        }&per=100`;
        if (!!this.props.search_query) {
            let search_query = encodeURI(this.props.search_query);
            url += `&search=${search_query}`;
        }
        $.ajax({
            url: url,
            type: "GET",
            context: this,
            headers: { Authorization: `Bearer ${this.props.jwt}` },
            success: function(response) {
                this.current_page += 1;
                this.total_attachment_count = response.meta.total_count;
                this.setState({
                    loading: false,
                    attachments: this.state.attachments.concat(response.data)
                });
            },
            error: function(xhr) {
                this.setState({ loading: false, error: true });
            },
            complete: function() {
                this.fetching = false;
            }
        });
    }

    fetchMoreAttachments = () => {
        if (!this.fetching) {
            if (this.state.attachments.length < this.total_attachment_count) {
                let attachment_list = this.refs.attachment_list;
                let scroll_threshold =
                    attachment_list.scrollHeight -
                    attachment_list.offsetHeight -
                    500;
                if (attachment_list.scrollTop >= scroll_threshold) {
                    this.getAttachments();
                }
            }
        }
    };

    renderAttachments() {
        if (!!this.state.loading) {
            return (
                <div className="adobe-notification">
                    <i className="fa fa-spinner fa-spin" />
                </div>
            );
        } else if (!!this.state.error) {
            return (
                <div className="adobe-notification">
                    <i className="fa fa-exclamation-triangle" />
                    <p>Unable to load files at this time</p>
                </div>
            );
        } else if (this.state.attachments.length === 0) {
            let message;
            if (!!this.props.search_query) {
                message = "No results match that search";
            } else {
                message = "This Brandfolder is empty";
            }
            return (
                <div className="adobe-notification">
                    <i className="fa fa-commenting" />
                    <p>{message}</p>
                </div>
            );
        } else {
            const attachments = this.state.attachments;
            const attachment_list = attachments.map(attachment => {
                return (
                    <li key={attachment.id}>
                        <Attachment
                            showProgressBar={this.showProgressBar}
                            attachment={attachment.attributes}
                            placing_file={this.state.placing_file}
                        />
                    </li>
                );
            });
            return <ul>{attachment_list}</ul>;
        }
    }

    renderProgressBar() {
        if (!!this.state.placing_file) {
            return <ProgressBar message="Adding file" />;
        }
    }

    render() {
        return (
            <div
                ref="attachment_list"
                onScroll={this.fetchMoreAttachments}
                className="adobe-attachment-list"
            >
                {this.renderAttachments()}
                {this.renderProgressBar()}
            </div>
        );
    }
}
